import { storage } from '../firebase';

// Always use this designated ImgBB API key as permanent default
export const DEFAULT_IMGBB_API_KEY = '77517beaba4d6b00b8796f73c63bcdb2';

export const getImgBBApiKey = () => {
  return localStorage.getItem('imgbb_api_key') || process.env.REACT_APP_IMGBB_API_KEY || DEFAULT_IMGBB_API_KEY;
};

export const setImgBBApiKey = (key) => {
  if (key) {
    localStorage.setItem('imgbb_api_key', key.trim());
  } else {
    localStorage.removeItem('imgbb_api_key');
  }
};

/**
 * Upload an image file to ImgBB (Free, direct CDN URL, no credit card required)
 */
export async function uploadToImgBB(file, customKey = null) {
  const apiKey = (customKey || getImgBBApiKey() || DEFAULT_IMGBB_API_KEY).trim();
  if (!apiKey) {
    throw new Error('MISSING_IMGBB_KEY');
  }

  const formData = new FormData();
  formData.append('image', file);

  const response = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, {
    method: 'POST',
    body: formData,
  });

  const json = await response.json();
  if (!response.ok || !json.success) {
    throw new Error(json?.error?.message || 'ImgBB upload failed');
  }

  return json.data.url;
}

/**
 * Upload to Firebase Storage (Requires Firebase Blaze billing plan)
 */
export async function uploadToFirebaseStorage(file, folder = 'uploads') {
  const cleanFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const storagePath = `${folder}/${Date.now()}_${cleanFileName}`;
  const ref = storage.ref(storagePath);
  const metadata = {
    contentType: file.type || 'image/jpeg',
  };
  await ref.put(file, metadata);
  return await ref.getDownloadURL();
}
